import React, { useEffect, useState } from "react";
import "./Countdown.css";
const FlipCard = ({ value, isRed }) => {
  const [isFlipping, setIsFlipping] = useState(false);
  const [displayValue, setDisplayValue] = useState(value);

  useEffect(() => {
    if (value !== displayValue) {
      setIsFlipping(true);
      const timer = setTimeout(() => {
        setDisplayValue(value);
        setIsFlipping(false);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [value, displayValue]);

  const formattedValue = String(value).padStart(2, "0");
  const formattedDisplayValue = String(displayValue).padStart(2, "0");

  return (
    <div className="st-flip-card">
      <div className={`st-flip-card-inner ${isFlipping ? "flipping" : ""}`}>
        <div className={`st-flip-card-front ${isRed ? "red" : ""}`}>
          {formattedValue}
        </div>
        <div className="st-flip-card-back">{formattedDisplayValue}</div>
      </div>
    </div>
  );
};

export default FlipCard;
